import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./securityReviewRaiseAChallenge.html";
import { schemas } from '#oaf_schema.registry';
import { WireI18n } from '~/modules/stores/i18nStore';
import { SECURITY_REVIEW_EDITOR_ROUTE, navigate } from '~/modules/stores/routerStore';
import { securityReviewStore, selectRaiseAChallengeText } from '~/modules/stores/securityReviewStore';
import { upsertQueryParam } from '~/modules/utilities/routingUtilities';
import { OpsSecurityOpsReviewStatus } from '~/modules/utilities/securityReviewUtilities';
import { WireSchema } from '~/modules/wires/WireSchema';
class SecurityReviewRaiseAChallenge extends LightningElement {
  constructor(...args) {
    super(...args);
    this.securityFeedbackItems = void 0;
    this.labels = {};
    this.sharedLabels = {};
    this.challengeSchema = void 0;
    this.showDetails = false;
  }
  i18nCallback(i18n) {
    this.labels = i18n.securityReviewRaiseAChallenge;
    this.sharedLabels = i18n.shared;
  }
  schemaConnected([challengeSchema]) {
    this.challengeSchema = challengeSchema;
  }
  handleShowDetails() {
    this.showDetails = true;
  }
  handleResubmit() {
    navigate(`/${SECURITY_REVIEW_EDITOR_ROUTE}?${upsertQueryParam('step', 'status')}`);
  }
  get showRaiseAChallenge() {
    return this.opsReviewStatus === OpsSecurityOpsReviewStatus.returnedOps || this.opsReviewStatus === OpsSecurityOpsReviewStatus.returnedProdSec;
  }
  get opsReviewStatus() {
    return securityReviewStore.getState().securityReviewOps.status;
  }
  get challengeText() {
    return selectRaiseAChallengeText(securityReviewStore.getState());
  }
  onChangeRaiseAChallenge(value) {
    securityReviewStore.setRaiseAChallengeText(value);
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(SecurityReviewRaiseAChallenge, {
  wire: {
    i18nCallback: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    },
    schemaConnected: {
      adapter: WireSchema,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          schema: [schemas['securityReview/plugins/RaiseAChallenge/Challenge']]
        };
      }
    }
  },
  fields: ["securityFeedbackItems", "labels", "sharedLabels", "challengeSchema", "showDetails"]
});
const __lwc_component_class_internal = _registerComponent(SecurityReviewRaiseAChallenge, {
  tmpl: _tmpl,
  sel: "appx-security-review-raise-achallenge",
  apiVersion: 62
});
export default __lwc_component_class_internal;